import { Injectable } from '@angular/core';
import { TMenuItem } from './sidebar.interfaces';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppStore } from '../../../store/app.store';
import { BehaviorSubject } from 'rxjs';

export const APP_MENU: TMenuItem[] = [
  {
    title: 'general',
    type: 'header',
  },
  {
    title: 'Home',
    icon: 'fa fa-calendar',
    active: false,
    type: 'simple',
    route: '/',
  },
  {
    title: 'Projects',
    icon: 'fa fa-tachometer-alt',
    active: false,
    type: 'simple',
    route: '/projects',
  },
];

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private toggled = false;

  _hasBackgroundImage = false;

  private _menuObservable: BehaviorSubject<TMenuItem[]> = new BehaviorSubject(
    APP_MENU,
  );

  private activeUrl = '';

  constructor(private router: Router, private store: AppStore) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((routeEvent) => {
        this.onRouteEvent(routeEvent as RouterEvent);
      });
    this.store.project.subscribe((project) => {
      const menu = this.createMenu(project);
      this._menuObservable.next(menu);
    });
  }

  private onRouteEvent(routeEvent: RouterEvent) {
    this.activeUrl = routeEvent.url;
    const menu = this.activateMenuItem(this._menuObservable.value);
    this._menuObservable.next(menu);
  }

  toggle() {
    this.toggled = !this.toggled;
  }

  getSidebarState() {
    return this.toggled;
  }

  setSidebarState(state: boolean) {
    this.toggled = state;
  }

  getMenuObservable() {
    return this._menuObservable.asObservable();
  }

  get hasBackgroundImage() {
    return this._hasBackgroundImage;
  }

  set hasBackgroundImage(hasBackgroundImage) {
    this._hasBackgroundImage = hasBackgroundImage;
  }

  private createMenu(project: any) {
    const menu = [...APP_MENU];
    if (project) {
      menu.push({
        title: project.name,
        icon: 'fa fa-tachometer-alt',
        active: false,
        type: 'dropdown',
        submenus: [
          {
            title: 'Контент',
            route: `/projects/project/${project.alias}/settings-content`,
          },
          {
            title: 'Конфиги',
            route: `/projects/project/${project.alias}/settings`,
          },
          {
            title: 'Версии',
            route: `/projects/project/${project.alias}/settings/versions`,
          },
        ],
      });
    }
    this.activateMenuItem(menu);
    return menu;
  }

  private activateMenuItem(menu: TMenuItem[]) {
    menu.map((item) => {
      if (item.type === 'dropdown') {
        let active = false;
        item.submenus.forEach((sub, i) => {
          const isActive = this.isActiveRoute(sub.route);
          item.submenus[i].active = isActive;
          if (isActive) active = true;
        });
        item.active = active;
        return item;
      }
      (<any>item).active = this.isActiveRoute((<any>item).route);
      return item;
    });
    return menu;
  }

  private isActiveRoute(validateRoute: string): boolean {
    if (this.activeUrl === validateRoute) return true;
    if (validateRoute !== '/' && this.activeUrl.startsWith(validateRoute))
      return true;
    return false;
  }
}
